import { render, staticRenderFns } from "./BrowserCard.vue?vue&type=template&id=20c71356"
import script from "./BrowserCard.vue?vue&type=script&lang=js"
export * from "./BrowserCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports